import React, { useEffect, useState } from "react";
import {
  DateInput,
  SelectInput,
  TextInput,
} from "../../components/common/ui/Inputs";
import Button from "../../components/common/ui/Button";
import Table from "../../components/common/table/Table";
import { history } from "../../_helpers";
import ExcelExport from "../../components/common/ui/Export/ExcelExport";
import { useDispatch, useSelector } from "react-redux";
import { masterActions, authActions } from "../../_store";
import generateXlsx from "../../components/common/export/generateXlsx";
import { showToastNotification } from "../../components/common/ui/NotificationModal/ToastNotication";
import { staffRequestAction } from "../../_store/staffRequest.slice";
import CustomLoader from "../../components/common/ui/Loader";
import privateConversation from "../../assets/svg/btn_icons/private-chat.svg";
import InitiateMessage from "../../assets/svg/btn_icons/iniate-messge.svg";
import { fDate, getCurrentDate, getPastDate, MinDate, Today } from "../../utils/formatTime";
import { UserRoleType } from "../../_helpers/enumerator";
import review from "../../assets/svg/btn_icons/review.svg";
import createicon from "../../assets/svg/btn_icons/create-btn-icon.svg";
import Swal from "sweetalert2";
import { getStoredValue, removeStoredValue } from "../../_helpers/storagehelper";
import { useNavigate } from "react-router-dom";

function StaffRequestList() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [showSearchFields, setShowSearchFields] = useState(false);
  const loggedUser = getStoredValue("user")?.ManagementUserID;

  let sorting = false; // to restrict the pagination issue

  const roleID = getStoredValue("user")?.UserRoleID;

  const facilityCode = useSelector((x) => x?.auth?.commonFacilityCode);
  const { RequestStatus, UserList } = useSelector((x) => x?.dropdownOptions);
  const isPageReloading = useSelector((state) => state.master?.isPageReload);
  const isPublicDefender = (roleID === UserRoleType?.PublicDefender || roleID === UserRoleType?.PublicDefenderAdmin);

  const staffRequestID = parseInt(process.env.REACT_APP_STAFF_REQUEST_ACCESSIBLE_FA, 10);
  const STAFF_REQUEST_ACCESSIBLE_FA = [staffRequestID];
  const PC_REQUEST_VIEWERS = JSON.parse(process.env.REACT_APP_PCR_REQUESTFORM_VIEWERS);
  const { isBacktoDashboard } = useSelector((state) => state.master);
  const {
    PODList,
    formTitleList,
    formTypeList,
    inmateMessageCount,
    publicDefenderList,
    staffRequestList,
    staffRequestSearchList,
    staffRequestDefenderSearchList,
    messageTypeList,
    LoadPrivateConversationRequestUnreadCountResponse,
    loading,
  } = useSelector((x) => x?.staffRequest);

  const sessionFeedbackList = getStoredValue("feedbackList") || [];

  const { ManagementUserID, UserRoleID } = useSelector((x) => x?.auth?.user);

  const [showPrivateConversationBtn, setShowPrivateConversationBtn] = useState(false);
  const [reviewFullData, setReviewFullData] = useState([]);
  const [isShowAcceptedByField, setIsShowAcceptedByField] = useState(false);

  const { isSignalRData } = useSelector((state) => state.auth);
  const [isloading, setisloading] = useState(false);

  const [errorMessage, setErrorMessage] = useState({
    CreatedStartDate: "",
    CreatedEndDate: ""
  });

  //load facility drop down
  useEffect(() => {
    dispatch(
      masterActions.LoadFacilityDropDown({
        facilityID: 0,
        activeStatus: 1,
      })
    );
  }, []);

  useEffect(() => {
    if (isPublicDefender) {
      //remove admin grid data
      dispatch(staffRequestAction?.resetAdminGridData());
    } else {
      //remove defender grid data
      dispatch(staffRequestAction?.resetPublicDefenderGridData());
    }
  }, []);

  useEffect(() => {
    dispatch(
      masterActions.GetPublicDefenderNotificationAlert({
        ManagementUserID: ManagementUserID,
        FacilityID: facilityCode,
      })
    ).then((response) => {
      const updatedMenuList =
        getStoredValue("menu_list") || response?.payload;

      if (updatedMenuList) {
        dispatch(authActions.updateMenuList(updatedMenuList));
      }
    });
    // notifyCount();
  }, []);

  //private conversation show and hide
  useEffect(() => {
    if (
      roleID === 1 ||
      roleID === 2 ||
      roleID === 3 ||
      roleID === 12 ||
      roleID === 13
    ) {
      if (PC_REQUEST_VIEWERS.includes(loggedUser)) {
        setShowPrivateConversationBtn(true);
        dispatch(
          staffRequestAction?.LoadPrivateConversationRequestUnreadCount({
            ManagementUserID: loggedUser,
            FacilityID: facilityCode,
          })
        );
      } else if (loggedUser === STAFF_REQUEST_ACCESSIBLE_FA[0]) {
        dispatch(
          staffRequestAction?.LoadFacilityAdminPCRequestPermission({
            ManagementUserID: loggedUser,
            FacilityID: facilityCode,
          })
        )
          .then((result) => {
            const data = result?.payload;
            for (let index = 0; index < data.length; index++) {
              if (data[index]?.RequestFormTypeID === 61) {
                if (
                  data[index]?.ActiveStatus === true &&
                  data[index]?.FormView === 1 &&
                  data[index]?.ISAllowAccess === 1
                ) {
                  setShowPrivateConversationBtn(true);
                } else {
                  setShowPrivateConversationBtn(false);
                }

                if (
                  data[index]?.ActiveStatus === true &&
                  data[index]?.FormView === 1 &&
                  data[index]?.ISAllowAccess === 1
                ) {
                  //
                  dispatch(
                    staffRequestAction?.LoadFacilityAdminPCRUnreadCount({
                      ManagementUserID: loggedUser,
                      FacilityID: facilityCode,
                    })
                  )
                    .then((result) => {
                      // const PCRequestUnReadCount =
                      //   result?.payload?.PCRequestUnReadCount;
                      // if (PCRequestUnReadCount > 0) {
                      //   setShowPrivateConversationBtn(true);
                      // } else {
                      //   setShowPrivateConversationBtn(false);
                      // }
                    })
                    .catch((err) => { });
                }
              }
            }
          })
          .catch((err) => { });
      } else {
        //
        dispatch(
          staffRequestAction.CheckPrivateConversationRequestEnabledorNot({
            UserID: loggedUser,
            FacilityID: facilityCode,
          })
        )
          .then((result) => {
            const data = result?.payload;
            if (data?.length === 0) return;
            for (let index = 0; index < data.length; index++) {
              const element = data[index];
              if (element.RequestFormTypeID === 61) {
                setShowPrivateConversationBtn(
                  element.ActiveStatus === true && element.FormView === 1
                );
                if (element.ActiveStatus === true && element.FormView === 1) {
                  dispatch(
                    staffRequestAction?.LoadPrivateConversationRequestUnreadCount(
                      {
                        ManagementUserID: loggedUser,
                        FacilityID: facilityCode,
                      }
                    )
                  );
                }
              }
            }
          })
          .catch((err) => {
            showToastNotification(err?.message, "error");
          });
      }
    }
  }, []);

  useEffect(() => {
    getMessageType();
  }, [facilityCode]);

  const getMessageType = () => {
    dispatch(
      staffRequestAction?.getMessageType({
        ManagementUserID: ManagementUserID,
        FacilityCode: facilityCode,
      })
    );
  };

  useEffect(() => {
    if (facilityCode === 0) return;
    dispatch(staffRequestAction?.getPODList(facilityCode))
      .then((result) => {
        const PODList = result?.payload;
        PODList?.unshift({ value: 0, label: "-- ALL --" });
        dispatch(staffRequestAction?.updatePODList(PODList));
      })
      .catch((err) => {
        showToastNotification("Failed to get POD List", "error");
      });

    dispatch(
      staffRequestAction?.getInmateMessageCount({
        FacilityCode: facilityCode,
        ManagementUserID: ManagementUserID,
      })
    );
  }, [facilityCode]);

  useEffect(() => {
    const searchList = { ...staffRequestSearchList };
    if (facilityCode !== 0) {
      searchList.FacilityID = facilityCode;
      dispatch(staffRequestAction?.setStaffRequestSearchList(searchList));
      // setStaffRequestSearch((prev) => ({
      //   ...prev,
      //   FacilityID: facilityCode,
      // }));
    } else {
      // Handle case when commonFacilityCode is 0, if necessary
      searchList.FacilityID = 0;
      dispatch(staffRequestAction?.setStaffRequestSearchList(searchList));
      // setStaffRequestSearch((prev) => ({
      //   ...prev,
      //   FacilityID: 0,
      // }));
    }
  }, [facilityCode]);

  //public defender
  useEffect(() => {
    if (facilityCode === 0) return;
    if (UserRoleID === UserRoleType?.PublicDefender) {
      //10
      dispatch(
        staffRequestAction?.GetManagementUserInfo({
          ManagementUserID: ManagementUserID,
        })
      )
        .then((result) => {
          const data = result?.payload;
          if (data?.IsAllowtoAccessOthersPDForm === "True") {
            setIsShowAcceptedByField(true);
          } else {
            setIsShowAcceptedByField(false);
          }
        })
        .catch((err) => {
          setIsShowAcceptedByField(false);
        });
    }
    if (isPublicDefender) {
      //API call
      const searchData = { ...staffRequestDefenderSearchList };
      searchData.FacilityID = facilityCode;
      searchData.ManagementUserID = ManagementUserID;
      dispatch(staffRequestAction?.setpublicDefenderSearchList(searchData));
      dispatch(staffRequestAction?.getPublicDefenderList(searchData))
        .then((result) => {
          if (result?.payload?.DataList?.length === 0) {
            const searchParams = { ...staffRequestDefenderSearchList };
            searchParams.PageNo = 1;
            searchParams.RowCountPerPage = 10;
            searchParams.FacilityID = facilityCode;
            searchParams.ManagementUserID = ManagementUserID;
            dispatch(
              staffRequestAction?.setpublicDefenderSearchList(searchParams)
            );
            dispatch(staffRequestAction?.getPublicDefenderList(searchParams));
          }
        })
        .catch((err) => { });
      dispatch(
        staffRequestAction?.getFormType({
          FacilityCode: facilityCode,
          ManagementUserID: ManagementUserID,
        })
      ); //for form type dropdown
      dispatch(staffRequestAction?.updateReviewStatus(false));
    }
  }, [
    facilityCode,
    // staffRequestDefenderSearchList?.PageNo,
    // staffRequestDefenderSearchList?.RowCountPerPage,

    isPageReloading,
  ]);

  //staff request list for admin
  useEffect(() => {
    if (facilityCode === 0) return;

    if (
      roleID !== UserRoleType?.PublicDefender &&
      roleID !== UserRoleType?.PublicDefenderAdmin
    ) {
      dispatch(
        staffRequestAction?.getFormTitle({
          FacilityCode: facilityCode,
          ManagementUserID: ManagementUserID,
        })
      ); //for form title dropdown
      const searchData = { ...staffRequestSearchList };
      searchData.FacilityID = facilityCode;
      searchData.ManagementUserID = ManagementUserID;
      setisloading(true);
      dispatch(staffRequestAction?.loadRequestFormSearchList(searchData))
        .then((result) => {
          if (result?.payload?.DataList?.length === 0) {
            const searchParams = { ...staffRequestSearchList };
            if (searchParams.PageNo != 1 || searchParams.RowCountPerPage != 10) {
              searchParams.PageNo = 1;
              searchParams.RowCountPerPage = 10;
              searchParams.FacilityID = facilityCode;
              searchParams.ManagementUserID = ManagementUserID;
              dispatch(
                staffRequestAction?.setStaffRequestSearchList(searchParams)
              );
              dispatch(
                staffRequestAction?.loadRequestFormSearchList(searchParams)
              );
            }
          }
          setisloading(false);
        })
        .catch((err) => { });
      dispatch(staffRequestAction?.updateReviewStatus(false));
    }
  }, [
    // staffRequestSearchList?.FacilityID,
    // staffRequestSearchList?.RowCountPerPage,
    // staffRequestSearchList?.PageNo,
    isPageReloading,
    facilityCode,
    ManagementUserID,
  ]);

  // cmd temp in slowness issue 
  //signalR  
  // useEffect(() => {
  //   switch (isSignalRData?.type) {
  //     case 'Request_AdminRemedy_CUD':
  //       if (facilityCode === 0) return;

  //       if (
  //         roleID !== UserRoleType?.PublicDefender &&
  //         roleID !== UserRoleType?.PublicDefenderAdmin
  //       ) {
  //         dispatch(
  //           staffRequestAction?.getFormTitle({
  //             FacilityCode: facilityCode,
  //             ManagementUserID: ManagementUserID,
  //             isNoLoading: true
  //           })
  //         ); //for form title dropdown
  //         const searchData = { ...staffRequestSearchList };
  //         searchData.FacilityID = facilityCode;
  //         searchData.ManagementUserID = ManagementUserID;
  //         searchData.isNoLoading = true
  //         dispatch(staffRequestAction?.loadRequestFormSearchList(searchData))
  //           .then((result) => {
  //             if (result?.payload?.DataList?.length === 0) {
  //               //
  //               const searchParams = { ...staffRequestSearchList };
  //               searchParams.PageNo = 1;
  //               searchParams.RowCountPerPage = 10;
  //               searchParams.FacilityID = facilityCode;
  //               searchParams.ManagementUserID = ManagementUserID;
  //               searchParams.isNoLoading = true
  //               dispatch(
  //                 staffRequestAction?.setStaffRequestSearchList(searchParams)
  //               );
  //               dispatch(
  //                 staffRequestAction?.loadRequestFormSearchList(searchParams)
  //               );
  //             }
  //           })
  //           .catch((err) => { });
  //         dispatch(staffRequestAction?.updateReviewStatus(false));
  //       }
  //       else {
  //         const searchDataResult = { ...staffRequestDefenderSearchList };
  //         searchDataResult.FacilityID = facilityCode;
  //         searchDataResult.ManagementUserID = ManagementUserID;
  //         searchDataResult.isNoLoading = true
  //         dispatch(staffRequestAction?.getPublicDefenderList(searchDataResult))
  //           .then((result) => {
  //             if (result?.payload?.DataList?.length === 0) {
  //               const searchParams = { ...staffRequestDefenderSearchList };
  //               searchParams.PageNo = 1;
  //               searchParams.RowCountPerPage = 10;
  //               searchParams.FacilityID = facilityCode;
  //               searchParams.ManagementUserID = ManagementUserID;
  //               searchParams.isNoLoading = true
  //               dispatch(staffRequestAction?.getPublicDefenderList(searchParams));
  //             }
  //           })
  //       }
  //       dispatch(
  //         masterActions.GetPublicDefenderNotificationAlert({
  //           ManagementUserID: ManagementUserID,
  //           FacilityID: getStoredValue("commonFacilityCode"),
  //           isNoLoading: true
  //         })
  //       ).then((response) => {
  //         const updatedMenuList =
  //           getStoredValue("menu_list") || response?.payload;

  //         if (updatedMenuList) {
  //           dispatch(authActions.updateMenuList(updatedMenuList));
  //         }
  //       });
  //       break;
  //     case 'Admin_Reply_Request_Form':

  //       if (isSignalRData?.message?.RequestAdminRemedyID || isSignalRData?.message?.RequestForumThreadID || isSignalRData?.message?.RequestVisitorFormID) {
  //         const threadIdToRemove = isSignalRData.message.RequestAdminRemedyID || isSignalRData?.message?.RequestForumThreadID || isSignalRData?.message?.RequestVisitorFormID;

  //         // For staff requests (non-Public Defender)
  //         if (roleID !== UserRoleType?.PublicDefender &&
  //           roleID !== UserRoleType?.PublicDefenderAdmin) {

  //           // Filter out the matching record
  //           const updatedList = staffRequestList?.DataList?.filter(
  //             item => item.RequestFormTypeID !== threadIdToRemove
  //           );

  //           // Update the state with the filtered list
  //           if (updatedList?.length !== staffRequestList?.DataList?.length) {
  //             dispatch(staffRequestAction?.setStaffRequestList({
  //               ...staffRequestList,
  //               DataList: updatedList,
  //               TotalRecordCount: staffRequestList.TotalRecordCount - 1,
  //             }));
  //           }
  //           dispatch(
  //             masterActions.GetLoadNotificationAlert({
  //               ManagementUserID: roleID.ManagementUserID,
  //               FacilityID: getStoredValue("commonFacilityCode"),
  //               isNoLoading: true
  //             })
  //           ).then((response) => {
  //             const updatedMenuList =
  //               getStoredValue("menu_list") || response?.payload;

  //             if (updatedMenuList) {
  //               dispatch(authActions.updateMenuList(updatedMenuList));
  //             }
  //           });
  //         }
  //       }
  //       break;
  //   }

  // }, [isSignalRData]);

  const columns = [
    {
      name: "Form Title",
      key: "RequestFormTitle",
      selector: (row) => row.RequestFormTitle,
      cell: (row) => (
        <div className={`d-flex gap-2 align-items-start `}>
          <div
            className={row?.IsFormEditAccess === 1 ? "Common_Link_Style" : ""}
            onClick={() => viewForm(row, reviewFullData)}
          >
            {row.RequestFormTitle}
          </div>
          {row?.UserRequestReadStatus === 0 && (
            <div class="newbutton-container">
              New
              <div class="border-animation"></div>
            </div>
          )}
        </div>
      ),
      sortable: true,
    },
    {
      width: "90px",
      name: "Inmate ID",
      key: "InmateResidentId",
      selector: (row) => row.InmateResidentId,
      sortable: true,
    },
    {
      name: "Inmate Full Name",
      key: "InmateName",
      selector: (row) => row.InmateName,
      sortable: true,
    },

    {
      width: "80px",
      name: "POD",
      key: "PODCode",
      selector: (row) => row.PodCode,
      sortable: true,
    },
    {
      width: "160px",
      name: "Created On",
      key: "RequestCreateDate",
      selector: (row) => row.RequestCreateDate,
      cell: (row) => (
        <div className="d-flex flex-wrap ">
          <div className="font-size-13 fw-500 ">{row.RequestCreateDate}</div>
        </div>
      ),
      sortable: true,
    },

    ...(UserRoleType?.PublicDefenderAdmin === UserRoleID ||
      isShowAcceptedByField
      ? [
        {
          name: "Accepted By",
          key: "ReqAssignToPDUserName",
          selector: (row) => row?.ReqAssignToPDUserName,
          sortable: true,
        },
      ]
      : []),
    {
      width: "160px",
      name: "Responded On",
      key: "RequestRespondDate",
      selector: (row) => row.RequestRespondDate,
      cell: (row) => (
        <div className="d-flex flex-wrap ">
          <div className="font-size-13 fw-500 ">
            {row.RequestRespondDate || "-"}
          </div>
        </div>
      ),
      sortable: true,
    },
    {
      width: "90px",
      name: "Status",
      key: "RequestCurrentStatus",
      selector: (row) => row.RequestCurrentStatus,
      cell: (row) =>
        row.RequestCurrentStatus === "Open" ? (
          <span
            style={{ marginleft: "10px" }}
            title="Open"
            className="status-open"
          >
            Open
          </span>
        ) : (
          <span
            style={{ marginleft: "10px" }}
            title="Closed"
            className="status-Closed"
          >
            Closed
          </span>
        ),
      sortable: true,
      sortFunction: (rowA, rowB) => {
        // Ensuring case-insensitive sorting
        const statusA = rowA.RequestCurrentStatus.toLowerCase();
        const statusB = rowB.RequestCurrentStatus.toLowerCase();

        if (statusA < statusB) {
          return -1;
        }
        if (statusA > statusB) {
          return 1;
        }
        return 0;
      },
    },
  ];

  const viewForm = (row, formDetails) => {
    Swal.close();
    if (row?.IsFormEditAccess === 0) return;
    const formType = row?.RequestFormType;
    if (sessionFeedbackList?.length > 0) {
      removeStoredValue("feedbackList");
    }

    if (
      UserRoleID !== UserRoleType?.SuperAdmin &&
      UserRoleID !== UserRoleType?.InvestigatorsStaff &&
      STAFF_REQUEST_ACCESSIBLE_FA?.includes(UserRoleID)
    ) {
      dispatch(
        staffRequestAction?.getRequestFormAccess({
          ManagementUserID: ManagementUserID,
          formID: row?.RequestFormTypeID,
          FacilityCode: facilityCode,
        })
      );
    }

    switch (formType) {
      case 1:
        history.navigate("StaffRequestList/VisitorRequestForm", {
          state: {
            formID: row?.RequestFormTypeID,
            RequestFormType: row?.RequestFormType,
            formDetails: formDetails,
            sourceFrom: "StaffRequestList",
          },
        });
        break;

      case 60:
        history.navigate("StaffRequestList/LegalResearchRequest", {
          state: {
            formID: row?.RequestFormTypeID,
            RequestFormType: row?.RequestFormType,
            formDetails: formDetails,
            sourceFrom: "StaffRequestList",
          },
        });
        break;

      case 2:
        history.navigate("StaffRequestList/RequestRemedyForm", {
          state: {
            formID: row?.RequestFormTypeID,
            RequestFormType: row?.RequestFormType,
            formDetails: formDetails,
            sourceFrom: "StaffRequestList",
          },
        });
        break;

      case 53:
        history.navigate("StaffRequestList/PublicDefenderForm", {
          state: {
            formID: row?.RequestFormTypeID,
            formDetails: formDetails,
            InmateResidentId: row?.InmateResidentId,
            InmateID: row?.InmateID,
            sourceFrom: "StaffRequestList",
          },
        });
        break;

      case 62:
        history.navigate("StaffRequestList/PublicDefenderFormCrisp", {
          state: {
            formID: row?.RequestFormTypeID,
            formDetails: formDetails,
            sourceFrom: "StaffRequestList",
          },
        });
        break;

      case 63:
        history.navigate("StaffRequestList/PublicDefenderServiceForm", {
          state: {
            formID: row?.RequestFormTypeID,
            formDetails: formDetails,
            sourceFrom: "StaffRequestList",
          },
        });
        break;

      case 59:
        history.navigate("StaffRequestList/PublicDefenderFormCrisp", {
          state: {
            formID: row?.RequestFormTypeID,
            formDetails: formDetails,
            sourceFrom: "StaffRequestList",
          },
        });
        break;

      default:
        break;
    }

    if (
      formType >= 3 &&
      formType !== 53 &&
      formType !== 59 &&
      formType !== 63 &&
      formType !== 60 &&
      formType !== 62
    ) {
      dispatch(staffRequestAction?.resetRequestFormInfoPayloadData())
      history.navigate("StaffRequestList/RequestFormInfo", {
        state: {
          formID: row?.RequestFormTypeID,
          RequestFormType: row?.RequestFormType,
          oldRequestFormTitle: row?.RequestFormTitle,
          InmateID: row?.InmateID,
          InmateResidentId: row?.InmateResidentId,
          formDetails: formDetails,
          sourceFrom: "StaffRequestList",
        },
      });
    }
  };

  const handleRowPerPage = (page) => {
    if (isPublicDefender) {
      const searchList = {
        ...staffRequestDefenderSearchList,
        ManagementUserID: loggedUser,
        PageNo: 1,
        RowCountPerPage: page,
        FacilityID: facilityCode,
      };
      dispatch(staffRequestAction?.setpublicDefenderSearchList(searchList));
      dispatch(staffRequestAction?.getPublicDefenderList(searchList));
      // setPublicDefenderSearch((prevState) => ({
      //   ...prevState,
      //   RowCountPerPage: page,
      // }));
    } else {
      const searchList = {
        ...staffRequestSearchList,
        ManagementUserID: loggedUser,
        RowCountPerPage: page,
        FacilityID: facilityCode,
        PageNo: 1,
      };
      dispatch(staffRequestAction?.setStaffRequestSearchList(searchList));
      dispatch(staffRequestAction?.loadRequestFormSearchList(searchList));
      // setStaffRequestSearch((prevState) => ({
      //   ...prevState,
      //   RowCountPerPage: page,
      // }));
    }
  };

  const handlePageChange = (page) => {
    if (sorting) {
      sorting = false;
      return;
    }
    if (isPublicDefender) {
      const searchList = { ...staffRequestDefenderSearchList };
      searchList.PageNo = page;
      searchList.FacilityID = facilityCode;
      searchList.ManagementUserID = loggedUser;
      dispatch(staffRequestAction?.setpublicDefenderSearchList(searchList));
      dispatch(staffRequestAction?.getPublicDefenderList(searchList));
      // setPublicDefenderSearch((prevState) => ({
      //   ...prevState,
      //   PageNo: page,
      // }));
    } else {
      const searchList = { ...staffRequestSearchList };
      searchList.PageNo = page;
      searchList.ManagementUserID = loggedUser;
      searchList.FacilityID = facilityCode;
      dispatch(staffRequestAction?.setStaffRequestSearchList(searchList));
      dispatch(staffRequestAction?.loadRequestFormSearchList(searchList));
      // setStaffRequestSearch((prevState) => ({
      //   ...prevState,
      //   PageNo: page,
      // }));
    }
  };

  const handleSort = (column, sortDirection) => {
    if (!column?.key) return;
    // setSorting(true);
    sorting = true;
    if (isPublicDefender) {
      const search = { ...staffRequestDefenderSearchList };
      const newSortOrder = search.SortBy.includes(column.key)
        ? search.SortBy.endsWith("ASC")
          ? "DESC"
          : "ASC"
        : "ASC";

      search.SortBy = `${column.key} ${newSortOrder}`;
      search.ManagementUserID = ManagementUserID;
      search.FacilityID = facilityCode;
      dispatch(staffRequestAction.setpublicDefenderSearchList(search));
      dispatch(
        staffRequestAction?.getPublicDefenderList({
          ...search,
          SortBy: `${column.key} ${newSortOrder}`,
        })
      );
    } else {
      const search = { ...staffRequestSearchList };
      const newSortOrder = search.SortBy.includes(column.key)
        ? search.SortBy.endsWith("ASC")
          ? "DESC"
          : "ASC"
        : "ASC";

      search.SortBy = `${column.key} ${newSortOrder}`;
      search.ManagementUserID = ManagementUserID;
      search.FacilityID = facilityCode;
      dispatch(staffRequestAction?.setStaffRequestSearchList(search));
      dispatch(
        staffRequestAction?.loadRequestFormSearchList({
          ...search,
          SortBy: `${column.key} ${newSortOrder}`,
        })
      );
    }
  };

  const handleChange = (e, select) => {
    if (isPublicDefender) {
      const searchList = { ...staffRequestDefenderSearchList };
      searchList.PageNo = 1;
      searchList.RowCountPerPage = 10;
      if (
        select === "CreatedStartDate" ||
        select === "CreatedEndDate" ||
        select === "ResponseStartDate" ||
        select === "ResponseEndDate"
      ) {
        const dateValue = fDate(e);
        searchList[select] = dateValue;
        dispatch(staffRequestAction?.setpublicDefenderSearchList(searchList));
        // setPublicDefenderSearch({
        //   ...publicDefenderSearch,
        //   [select]: dateValue,
        // });
        return;
      }
      if (
        select === "pRequestFormTypeID" ||
        select === "pRequestAdminTypeID" ||
        select === "ActiveStatus" ||
        select === "PodID"
      ) {
        if (
          select === "pRequestFormTypeID" ||
          select === "pRequestAdminTypeID"
        ) {
          searchList["pRequestAdminTypeID"] =
            roleID === UserRoleType?.PublicDefender ? 2 : e?.value;
          searchList["pRequestFormTypeID"] =
            roleID === UserRoleType?.PublicDefenderAdmin ? 0 : e?.value;
        }
        // searchList[select] = e?.value;
        searchList[select] =
          e?.value !== undefined
            ? e?.value
            : select === "pRequestFormTypeID"
              ? 0
              : select === "pRequestAdminTypeID"
                ? 2
                : select === "ActiveStatus"
                  ? 2
                  : select === "PodID"
                    ? 0
                    : 2;
        searchList.ManagementUserID = ManagementUserID;
        searchList.PageNo = 1;
        searchList.FacilityID = facilityCode;
        dispatch(staffRequestAction?.setpublicDefenderSearchList(searchList));
        const isValid = handlechecksearchDate();
        if (!isValid) return;
        dispatch(staffRequestAction?.getPublicDefenderList(searchList));
        return;
      }
      const { name, value } = e?.target;
      // const { name, value } = e?.target;
      if (name === "InmateResidentID") {
        const regex = /^\d*$/;
        if (!regex.test(value)) return;
      }
      searchList[name] = value;
      dispatch(staffRequestAction?.setpublicDefenderSearchList(searchList));
      // setPublicDefenderSearch({
      //   ...publicDefenderSearch,
      //   [name]: value,
      // });
    } else {
      const searchList = { ...staffRequestSearchList };
      // searchList.PageNo = 1;
      // searchList.RowCountPerPage = 10;
      //for all the user
      if (
        select === "CreatedStartDate" ||
        select === "CreatedEndDate" ||
        select === "ResponseStartDate" ||
        select === "ResponseEndDate"
      ) {
        searchList[select] = fDate(e);
        dispatch(staffRequestAction?.setStaffRequestSearchList(searchList));

        // setStaffRequestSearch({
        //   ...staffRequestSearch,
        //   [select]: fDate(e),
        // });
        return;
      }

      if (
        select === "RequestFormTypeID" ||
        select === "ActiveStatus" ||
        select === "PodID" ||
        select === "IsCreatedByMGUser"
      ) {
        // const searchData = { ...staffRequestSearch };
        // searchData[select] = e?.value;
        searchList[select] =
          e?.value !== undefined
            ? e?.value
            : select === "RequestFormTypeID"
              ? 0
              : select === "ActiveStatus"
                ? 2
                : select === "PodID"
                  ? 0
                  : 2;
        searchList.ManagementUserID = ManagementUserID;
        searchList.PageNo = 1;
        searchList.FacilityID = facilityCode;
        searchList.PageNo = 1;
        searchList.RowCountPerPage = 10;
        dispatch(staffRequestAction?.setStaffRequestSearchList(searchList));
        const isValid = handlechecksearchDate();
        if (!isValid) return;
        dispatch(staffRequestAction?.loadRequestFormSearchList(searchList));
        return;
      }

      const { name, value } = e?.target;
      if (name === "InmateResidentID") {
        const regex = /^\d*$/;
        if (!regex.test(value)) return;
      }
      searchList[name] = value;
      dispatch(staffRequestAction?.setStaffRequestSearchList(searchList));

    }
  };

  //
  const handleDateBlur = (e, fieldName) => {
    setErrorMessage({
      CreatedStartDate: "",
      CreatedEndDate: ""
    });

    const value = e.target.value;
    const minDate = new Date(2017, 0, 1);
    const today = new Date();

    const staffSearchList = isPublicDefender ? staffRequestDefenderSearchList : staffRequestSearchList;

    if (!value) {
      // user cleared date → reset that field only
      const updatedParam = {
        ...staffSearchList,
        [fieldName]: "", // clear that date
      };
      if (isPublicDefender)
        dispatch(staffRequestAction?.setpublicDefenderSearchList(updatedParam))
      else
        dispatch(staffRequestAction?.setStaffRequestSearchList(updatedParam));
      return;
    }

    const inputDate = new Date(value);
    const isValidDate = inputDate >= minDate && inputDate <= today;

    // Always clone fresh data (avoid stale Redux state)
    let updatedStartDate = staffSearchList?.CreatedStartDate;
    let updatedEndDate = staffSearchList?.CreatedEndDate;

    if (fieldName === "CreatedStartDate") {
      if (isValidDate) {
        updatedStartDate = fDate(value);

        // Auto adjust End Date if missing or out of range
        if (updatedEndDate) {
          const start = new Date(updatedStartDate);
          const end = new Date(updatedEndDate);

          const oneYearLater = new Date(start);
          oneYearLater.setFullYear(start.getFullYear() + 1);

          // If end date < start date or > 1 year
          if (end < start || end > oneYearLater) {
            updatedEndDate = fDate(oneYearLater <= today ? oneYearLater : today);
          }
        } else {
          // No end date selected yet → auto-set 1 year later
          const autoEnd = new Date(inputDate);
          autoEnd.setFullYear(inputDate.getFullYear() + 1);
          updatedEndDate = fDate(autoEnd <= today ? autoEnd : today);
        }
      } else {
        updatedStartDate = staffSearchList?.CreatedStartDate;
      }
    }

    if (fieldName === "CreatedEndDate") {
      if (isValidDate) {
        updatedEndDate = fDate(value);

        // Auto adjust Start Date if missing or out of range
        if (updatedStartDate) {
          const start = new Date(updatedStartDate);
          const end = new Date(updatedEndDate);

          const oneYearBefore = new Date(end);
          oneYearBefore.setFullYear(end.getFullYear() - 1);

          // If start date > end date or < 1 year before
          if (start > end || start < oneYearBefore) {
            updatedStartDate = fDate(oneYearBefore >= minDate ? oneYearBefore : minDate);
          }
        } else {
          // No start date → auto-set 1 year before
          const autoStart = new Date(inputDate);
          autoStart.setFullYear(inputDate.getFullYear() - 1);
          updatedStartDate = fDate(autoStart >= minDate ? autoStart : minDate);
        }
      } else {
        updatedEndDate = staffSearchList?.CreatedEndDate;
      }
    }

    // ✅ Update Redux state immediately
    const updatedParam = {
      ...staffSearchList,
      CreatedStartDate: updatedStartDate,
      CreatedEndDate: updatedEndDate,
    };
    if (isPublicDefender)
      dispatch(staffRequestAction?.setpublicDefenderSearchList(updatedParam))
    else
      dispatch(staffRequestAction?.setStaffRequestSearchList(updatedParam));

    // -------------------------------------------------------------------



    // let { value } = e.target;
    // let isFromValid = true;
    // let isToValid = true;

    // if (fieldName === "CreatedStartDate") {
    //   if (
    //     staffRequestSearchList.CreatedEndDate &&
    //     new Date(value) > new Date(staffRequestSearchList.CreatedEndDate)
    //   ) {
    //     // Invalid: FromDate cannot be after ToDate
    //     isFromValid = false;
    //   }
    // } else if (fieldName === "CreatedEndDate") {
    //   if (
    //     staffRequestSearchList.CreatedStartDate &&
    //     new Date(value) < new Date(staffRequestSearchList.CreatedStartDate)
    //   ) {
    //     // Invalid: ToDate cannot be before FromDate
    //     isToValid = false;
    //   }
    // }

    // // Define date format used
    // const minDate = MinDate();
    // const today = Today();
    // const valueDate = new Date(value);
    // const isValidDate = valueDate >= minDate && valueDate <= today;

    // let updatedParam = {
    //   ...staffRequestSearchList,
    //   CreatedStartDate:
    //     fieldName === "CreatedStartDate"
    //       ? isFromValid && isValidDate
    //         ? value
    //         : ""
    //       : staffRequestSearchList.CreatedStartDate, // preserve existing value
    //   CreatedEndDate:
    //     fieldName === "CreatedEndDate"
    //       ? isToValid && isValidDate
    //         ? value
    //         : ""
    //       : staffRequestSearchList.CreatedEndDate, // preserve existing value
    // };
    // dispatch(staffRequestAction?.setStaffRequestSearchList(updatedParam));
  };

  const handleDateEnterKey = (event, name) => {

    // if (event.key === "Enter") {
    //   const currentDate = new Date();

    //   // Set today's date using the same logic as your handleDateChange
    //   handleChange(currentDate, name);
    // }

    const regex = /^[0-9/]$/; // Allow numbers and "/"

    if (
      !regex.test(event.key) &&
      event.key !== "Backspace" &&
      event.key !== "Delete" &&
      !(event.ctrlKey && event.key === "v")
    ) {
      event.preventDefault();
    }

    // Auto-insert '/' when typing
    const input = event.target.value;

    if (event.key !== "Backspace" && event.key !== "Delete") {
      if (input?.length === 2 || input?.length === 5) {
        event.target.value = input + "/";
      }
    }

    // ✅ Handle Enter key
    if (event.key === "Enter") {
      const minDate = new Date(2017, 0, 1); // January 1, 2017
      const today = new Date();
      event.preventDefault();

      const inputValue = event.target.value;
      if (inputValue && inputValue.length === 10) {
        const [day, month, year] = inputValue.split("/").map(Number);
        const inputDate = new Date(year, month - 1, day);

        // Check if valid
        if (isNaN(inputDate)) {
          alert("Invalid date format");
          return;
        }

        // Clamp within min/max
        if (inputDate < minDate) {
          event.target.value = fDate(minDate);
        } else if (inputDate > today) {
          event.target.value = fDate(today);
        }
      }
      // ✅ Call blur handler manually with the latest value
      handleDateBlur(event, name, event.target.value);
    }
  };

  const handleResDateBlur = (e, fieldName) => {
    let { value } = e.target;
    let isFromValid = true;
    let isToValid = true;

    if (fieldName === "ResponseStartDate") {
      if (
        staffRequestSearchList.ResponseEndDate &&
        new Date(value) > new Date(staffRequestSearchList.ResponseEndDate)
      ) {
        // Invalid: FromDate cannot be after ToDate
        isFromValid = false;
      }
    } else if (fieldName === "ResponseEndDate") {
      if (
        staffRequestSearchList.ResponseStartDate &&
        new Date(value) < new Date(staffRequestSearchList.ResponseStartDate)
      ) {
        // Invalid: ToDate cannot be before FromDate
        isToValid = false;
      }
    }

    // Define date format used
    const minDate = MinDate();
    const today = Today();
    const valueDate = new Date(value);
    const isValidDate = valueDate >= minDate && valueDate <= today;

    let updatedParam = {
      ...staffRequestSearchList,
      ResponseStartDate:
        fieldName === "ResponseStartDate"
          ? isFromValid && isValidDate
            ? value
            : ""
          : staffRequestSearchList.ResponseStartDate, // preserve existing value
      ResponseEndDate:
        fieldName === "ResponseEndDate"
          ? isToValid && isValidDate
            ? value
            : ""
          : staffRequestSearchList.ResponseEndDate, // preserve existing value
    };
    dispatch(staffRequestAction?.setStaffRequestSearchList(updatedParam));
    // ✅ Call blur handler manually with the latest value

    handleDateBlur(e, fieldName, e.target.value);
  };

  const handledropdownlist = () => {
    if (isPublicDefender) {
      //API call     
      dispatch(staffRequestAction?.getFormType({ FacilityCode: facilityCode, ManagementUserID: ManagementUserID, }));

    }
  }

  const handleSearchReset = () => {
    setErrorMessage({});
    if (isPublicDefender) {
      dispatch(staffRequestAction?.resetPublicDefenderSearchList());
      const searchData = { ...staffRequestDefenderSearchList };
      searchData.CreatedStartDate = getPastDate(12);
      searchData.CreatedEndDate = getCurrentDate(1);
      searchData.pRequestAdminTypeID = 2;
      searchData.ActiveStatus = 2;
      searchData.ResponseStartDate = "";
      searchData.ResponseEndDate = "";
      searchData.PodID = 0;
      searchData.InmateID = "";
      searchData.InmateResidentID = "";
      searchData.LastName = "";
      searchData.FirstName = "";
      searchData.FacilityID = facilityCode;
      searchData.pRequestFormTypeID = 0;
      searchData.ManagementUserID = loggedUser;
      searchData.PageNo = 1;
      searchData.RowCountPerPage = 10;
      searchData.SortBy = "RequestCreateDate DESC";
      setisloading(true);
      dispatch(staffRequestAction?.getPublicDefenderList(searchData)).then(
        (x) => {
          setisloading(false);
          //updating notification
          dispatch(
            masterActions.GetLoadNotificationAlert({
              ManagementUserID: ManagementUserID,
              FacilityID: facilityCode,
            })
          )
            .then((response) => {
              const updatedMenuList =
                getStoredValue("menu_list") ||
                response?.payload;

              if (updatedMenuList) {
                dispatch(authActions.updateMenuList(updatedMenuList));
              }
            })
            .then((x) => {
              dispatch(
                masterActions.GetPublicDefenderNotificationAlert({
                  ManagementUserID: ManagementUserID,
                  FacilityID: facilityCode,
                })
              ).then((response) => {
                const updatedMenuList =
                  getStoredValue("menu_list") ||
                  response?.payload;

                if (updatedMenuList) {
                  dispatch(authActions.updateMenuList(updatedMenuList));
                }
              });
            });
        }
      );
      handledropdownlist();
    } else {
      dispatch(
        staffRequestAction?.getFormTitle({
          FacilityCode: facilityCode,
          ManagementUserID: ManagementUserID,
        })
      );
      dispatch(staffRequestAction?.resetStaffRequestSearcList());
      const searchList = { ...staffRequestSearchList };
      searchList.FacilityID = facilityCode;
      searchList.InmatesId = 0;
      searchList.InmateResidentID = "";
      searchList.PodID = 0;
      searchList.RequestFormTypeID = 0;
      searchList.UserFirstName = "";
      searchList.UserLastName = "";
      searchList.ActiveStatus = 2;
      searchList.CreatedStartDate = getPastDate(12);
      searchList.CreatedEndDate = getCurrentDate(1);
      searchList.ResponseStartDate = "";
      searchList.ResponseEndDate = "";
      searchList.ManagementUserID = loggedUser;
      searchList.IsCreatedByMGUser = 2;
      searchList.PageNo = 1;
      searchList.RowCountPerPage = 10;
      searchList.SortBy = "RequestCreateDate DESC";
      dispatch(staffRequestAction?.setStaffRequestSearchList(searchList));
      dispatch(staffRequestAction?.loadRequestFormSearchList(searchList)).then(
        (x) => {
          //updating notification
          dispatch(
            masterActions.GetLoadNotificationAlert({
              ManagementUserID: ManagementUserID,
              FacilityID: facilityCode,
            })
          )
            .then((response) => {
              const updatedMenuList =
                getStoredValue("menu_list") ||
                response?.payload;

              if (updatedMenuList) {
                dispatch(authActions.updateMenuList(updatedMenuList));
              }
            })
            .then((x) => {
              dispatch(
                masterActions.GetPublicDefenderNotificationAlert({
                  ManagementUserID: ManagementUserID,
                  FacilityID: facilityCode,
                })
              ).then((response) => {
                const updatedMenuList =
                  getStoredValue("menu_list") ||
                  response?.payload;

                if (updatedMenuList) {
                  dispatch(authActions.updateMenuList(updatedMenuList));
                }
              });
            });
        }
      );
    }
  };

  const removeAceptByFromArr = (arr) => {
    return arr.map((obj) => {
      const newObj = { ...obj }; // Create a shallow copy
      delete newObj["Accepted By"]; // Remove the key
      return newObj;
    });
  };

  const exportDocAsExcel = () => {
    let generateExcelColumns = [
      "Form Title",
      "Inmate ID",
      "Inmate Full name",
      "POD",
      "Created On",
      "Respond On",
      "Status",
    ];

    let generateExcelColumnsWithAcceptBy = [
      "Form Title",
      "Inmate ID",
      "Inmate Full name",
      "POD",
      "Created On",
      "Accepted By",
      "Responded On",
      "Status",
    ];
    if (isPublicDefender) {
      //public defender admin
      const searchData = { ...staffRequestDefenderSearchList };
      searchData.RowCountPerPage = publicDefenderList?.TotalRecordCount;
      searchData.exportExcel = true;
      searchData.pageNo = 1;
      searchData.ManagementUserID = ManagementUserID;
      searchData.FacilityID = facilityCode;
      dispatch(staffRequestAction?.getPublicDefenderList(searchData))
        .then((result) => {
          const dataList = result?.payload?.DataList;
          let exportData =
            result &&
            dataList?.map((obj) => ({
              "Form Title": obj?.RequestFormTitle,
              "Inmate ID": obj?.InmateResidentId,
              "Inmate Full name": obj?.InmateName,
              POD: obj?.PodCode,
              "Created On": obj?.RequestCreateDate,
              "Accepted By": obj?.ReqAssignToPDUserName,
              "Respond On": obj?.RequestRespondDate,
              Status: obj?.RequestCurrentStatus,
            }));
          const columnName =
            UserRoleType?.PublicDefenderAdmin === UserRoleID ||
              isShowAcceptedByField
              ? generateExcelColumnsWithAcceptBy
              : generateExcelColumns;

          const filterData =
            UserRoleType?.PublicDefenderAdmin === UserRoleID ||
              isShowAcceptedByField
              ? exportData
              : removeAceptByFromArr(exportData);

          generateXlsx(filterData, columnName, "Requests_List");
        })
        .catch((err) => {
          showToastNotification(err?.message, "error");
        });
      return;
    } else {
      const search = { ...staffRequestSearchList };
      search.RowCountPerPage = staffRequestList?.TotalRecordCount;
      search.exportExcel = true;
      search.ManagementUserID = ManagementUserID;
      search.FacilityID = facilityCode;
      search.pageNo = 1;

      dispatch(staffRequestAction?.loadRequestFormSearchList(search))
        .then((result) => {
          const dataList = result?.payload?.DataList;
          let exportData =
            result &&
            dataList?.map((obj) => ({
              "Form Title": obj?.RequestFormTitle,
              "Inmate ID": obj?.InmateResidentId,
              "Inmate Full name": obj?.InmateName,
              POD: obj?.PodCode,
              "Created Date": obj?.RequestCreateDate,
              "Respond On": obj?.RequestRespondDate,
              Status: obj?.RequestCurrentStatus,
            }));
          generateXlsx(exportData, generateExcelColumns, "Requests_List");
        })
        .catch((err) => {
          showToastNotification(err?.message, "error");
        });
    }
  };

  const handlechecksearchDate = () => {
    const { CreatedStartDate, CreatedEndDate } = isPublicDefender ? staffRequestDefenderSearchList : staffRequestSearchList;

    if (!CreatedStartDate || !CreatedEndDate) {
      setErrorMessage({
        CreatedStartDate: !CreatedStartDate ? "Please select From Date." : "",
        CreatedEndDate: !CreatedEndDate ? "Please select End Date." : "",
      });
      return false;
    }
    return true;
  }

  const handleSearchSubmit = (e) => {
    e?.preventDefault();
    const isValid = handlechecksearchDate();
    if (!isValid) return;

    if (isPublicDefender) {
      setErrorMessage({})
      const searchData = { ...staffRequestDefenderSearchList };
      searchData.PageNo = 1;
      searchData.RowCountPerPage = 10;
      searchData.FacilityID = facilityCode;
      searchData.ManagementUserID = ManagementUserID;
      dispatch(staffRequestAction?.getPublicDefenderList(searchData));
      dispatch(staffRequestAction?.setpublicDefenderSearchList(searchData));
      //updating notification
      dispatch(
        masterActions.GetLoadNotificationAlert({
          ManagementUserID: ManagementUserID,
          FacilityID: facilityCode,
        })
      )
        .then((response) => {
          const updatedMenuList =
            getStoredValue("menu_list") || response?.payload;

          if (updatedMenuList) {
            dispatch(authActions.updateMenuList(updatedMenuList));
          }
        })
        .then((x) => {
          dispatch(
            masterActions.GetPublicDefenderNotificationAlert({
              ManagementUserID: ManagementUserID,
              FacilityID: facilityCode,
            })
          ).then((response) => {
            const updatedMenuList =
              getStoredValue("menu_list") ||
              response?.payload;

            if (updatedMenuList) {
              dispatch(authActions.updateMenuList(updatedMenuList));
            }
          });
        });
      handledropdownlist();
    } else {
      const { CreatedStartDate, CreatedEndDate } = staffRequestSearchList;

      if (!CreatedStartDate || !CreatedEndDate) {
        setErrorMessage({
          CreatedStartDate: !CreatedStartDate ? "Please select From Date." : "",
          CreatedEndDate: !CreatedEndDate ? "Please select End Date." : "",
        });
        return;
      }
      setErrorMessage({})
      const searchData = { ...staffRequestSearchList };
      searchData.FacilityID = facilityCode;
      searchData.ManagementUserID = ManagementUserID;
      searchData.PageNo = 1;
      searchData.RowCountPerPage = 10;
      dispatch(staffRequestAction?.setStaffRequestSearchList(searchData));
      dispatch(
        staffRequestAction?.getFormTitle({
          FacilityCode: facilityCode,
          ManagementUserID: ManagementUserID,
        })
      );
      setisloading(true);
      dispatch(staffRequestAction?.loadRequestFormSearchList(searchData))
        .then((x) => {
          setisloading(false);
          //updating notification
          dispatch(
            masterActions.GetLoadNotificationAlert({
              ManagementUserID: ManagementUserID,
              FacilityID: facilityCode,
            })
          ).then((response) => {
            const updatedMenuList =
              getStoredValue("menu_list") ||
              response?.payload;

            if (updatedMenuList) {
              dispatch(authActions.updateMenuList(updatedMenuList));
            }
          });
        })
        .then((x) => {
          dispatch(
            masterActions.GetPublicDefenderNotificationAlert({
              ManagementUserID: ManagementUserID,
              FacilityID: facilityCode,
            })
          ).then((response) => {
            const updatedMenuList =
              getStoredValue("menu_list") ||
              response?.payload;

            if (updatedMenuList) {
              dispatch(authActions.updateMenuList(updatedMenuList));
            }
          });
        });
    }
    if (UserRoleID === UserRoleType?.PublicDefender) {
      //10
      dispatch(
        staffRequestAction?.GetManagementUserInfo({
          ManagementUserID: ManagementUserID,
        })
      )
        .then((result) => {
          const data = result?.payload;
          if (data?.IsAllowtoAccessOthersPDForm === "True") {
            setIsShowAcceptedByField(true);
          } else {
            setIsShowAcceptedByField(false);
          }
        })
        .catch((err) => {
          setIsShowAcceptedByField(false);
        });
    }
  };

  const handleReviewRequest = () => {
    dispatch(staffRequestAction?.updateIndexValue(0));
    if (isPublicDefender) {
      /* public defender log */
      const searchData = { ...staffRequestDefenderSearchList };
      if (searchData?.ActiveStatus === 2 || searchData?.ActiveStatus === 3) {
        // const reviewPayload = {
        //   facilityID: facilityCode,
        //   inmateResidentId: "",
        //   userFirstName: "",
        //   userLastName: "",
        //   podID: 0,
        //   pRequestFormTypeID: 0,
        //   pRequestAdminTypeID: 2,
        //   activeStatus: 2,
        //   createStartDate: "",
        //   createEndDate: "",
        //   resStartDate: "",
        //   resEndDate: "",
        //   publicDefenderUserID: loggedUser,
        //   pageNo: 1,
        //   RowCountPerPage: 1000,
        //   SortBy: "RequestCreateDate DESC",
        // };
        searchData.FacilityID = facilityCode;
        searchData.ManagementUserID = ManagementUserID;
        searchData.ActiveStatus =
          searchData.ActiveStatus === 3 ? 2 : searchData.ActiveStatus;
        searchData.PageNo = 1;
        searchData.RowCountPerPage = publicDefenderList?.TotalRecordCount;
        dispatch(
          staffRequestAction?.PublicDefenderRequestReviewList(searchData)
        )
          .then((result) => {
            const data = result?.payload?.DataList;
            if (data?.length > 0) {
              setReviewFullData(data?.payload);
              viewForm(data[0], result?.payload);
              dispatch(staffRequestAction?.updateReviewStatus(true));
            } else {
              showToastNotification("There is no requests in NEW status.");
            }
          })
          .catch((err) => {
            showToastNotification("Failed to get review form data.", "error");
          });
      } else {
        showToastNotification("There is no requests in NEW Status.");
        return;
      }
    } else {
      //admin
      const searchData = { ...staffRequestSearchList };
      if (searchData?.ActiveStatus === 2 || searchData?.ActiveStatus === 3) {
        // const reviewData = {
        //   facilityID: facilityCode,
        //   inmateId: staffRequestSearchList?.InmatesId,
        //   inmateResidentID: staffRequestSearchList?.InmateResidentID,
        //   podID: staffRequestSearchList?.PodID,
        //   requestFormTypeID: staffRequestSearchList?.RequestFormTypeID,
        //   inmateFirstName: staffRequestSearchList?.UserFirstName,
        //   inmateLastName: staffRequestSearchList?.UserLastName,
        //   activeStatus: 2,
        //   createStartDate: staffRequestSearchList?.CreatedStartDate,
        //   createEndDate: staffRequestSearchList?.CreatedEndDate,
        //   respondStartDate: staffRequestSearchList?.ResponseStartDate,
        //   respondEndDate: staffRequestSearchList?.ResponseEndDate,
        //   managementUserID: loggedUser,
        //   SortBy: "RequestCreateDate DESC",
        //   pageNo: 1,
        //   rowPageCount: 1000,
        //   isReviewData: true,
        // };
        searchData.PageNo = 1;
        searchData.RowCountPerPage = staffRequestList?.TotalRecordCount;
        searchData.FacilityID = facilityCode;
        searchData.ActiveStatus =
          searchData.ActiveStatus === 3 ? 2 : searchData.ActiveStatus;
        searchData.ManagementUserID = ManagementUserID;
        dispatch(staffRequestAction?.LoadRequestReviewAllList(searchData))
          .then((result) => {
            const data = result?.payload?.DataList;
            if (data?.length > 0) {
              setReviewFullData(data?.payload);
              viewForm(data[0], result?.payload);
              dispatch(staffRequestAction?.updateReviewStatus(true));
            } else {
              showToastNotification("There is no requests in PENDING status.");
            }
          })
          .catch((err) => {
            showToastNotification("Failed to get review form data.", "error");
          });
      } else {
        showToastNotification("There is no requests in NEW Status.");
        return;
      }
    }
  };

  const handleMessageToInmate = () => {
    history?.navigate("StaffRequestList/MessageToInmate");
    dispatch(staffRequestAction?.resetMessageToInmateSearchList());
  };

  if (loading || isloading) return <CustomLoader />;

  const renderSearch = () => {
    return (
      <form onSubmit={(e) => handleSearchSubmit(e)}>
        <div className="row">
          <div className="col-sm-6 col-md-6 col-lg-4">
            <div className="form-floating mb-3">
              <SelectInput
                options={isPublicDefender ? formTypeList : formTitleList
                }
                name={isPublicDefender ? // ? "pRequestAdminTypeID"
                  roleID === UserRoleType?.PublicDefender
                    ? "pRequestFormTypeID"
                    : "pRequestAdminTypeID"
                  : "RequestFormTypeID"
                }
                label={isPublicDefender
                  ? "Type"
                  : "Form Title"
                }
                handleChange={(e) =>
                  handleChange(
                    e,
                    isPublicDefender ? // ? "pRequestAdminTypeID"
                      roleID === UserRoleType?.PublicDefender
                        ? "pRequestFormTypeID"
                        : "pRequestAdminTypeID"
                      : "RequestFormTypeID"
                  )
                }
                value={isPublicDefender
                  ? roleID === UserRoleType?.PublicDefender
                    ? staffRequestDefenderSearchList?.pRequestFormTypeID
                    : staffRequestDefenderSearchList?.pRequestAdminTypeID
                  : staffRequestSearchList?.RequestFormTypeID
                }
                isClearable={isPublicDefender
                  ? roleID === UserRoleType?.PublicDefender
                    ? staffRequestDefenderSearchList?.pRequestFormTypeID !== 0
                    : staffRequestDefenderSearchList?.pRequestAdminTypeID !==
                    2
                  : staffRequestSearchList?.RequestFormTypeID
                }
              />
            </div>
          </div>

          <div className="col-sm-6 col-md-6 col-lg-4">
            <div className="form-floating mb-3">
              <DateInput
                required={true}
                label="Created Start Date"
                name={"CreatedStartDate"}
                handleChange={(e) => handleChange(e, "CreatedStartDate")}
                placeholderText="Select a date"
                yearDropDown={true}
                // value={
                //   roleID === 1
                //     ? staffRequestSearchList?.CreatedStartDate
                //     : publicDefenderSearch?.CreatedStartDate
                // }
                value={
                  isPublicDefender
                    ? staffRequestDefenderSearchList?.CreatedStartDate
                    : staffRequestSearchList?.CreatedStartDate
                }
                minDate={new Date(2017, 0, 1)}
                maxDate={
                  (isPublicDefender && staffRequestDefenderSearchList?.CreatedEndDate !== "")
                    ? staffRequestDefenderSearchList?.CreatedEndDate :
                    staffRequestSearchList?.CreatedEndDate !== ""
                      ? staffRequestSearchList?.CreatedEndDate
                      : new Date()
                }
                isClearable={
                  false
                }
                errorMessage={errorMessage}
                handleBlur={(e) => handleDateBlur(e, "CreatedStartDate")}
                handleKeyDown={(e) => handleDateEnterKey(e, "CreatedStartDate")}
              />
            </div>
          </div>

          <div className="col-sm-6 col-md-6 col-lg-4">
            <div className="form-floating mb-3">
              <DateInput
                required={true}
                label="Created End Date"
                name="CreatedEndDate"
                handleChange={(e) => handleChange(e, "CreatedEndDate")}
                placeholderText="Select a date"
                yearDropDown={true}
                value={isPublicDefender
                  ? staffRequestDefenderSearchList?.CreatedEndDate
                  : staffRequestSearchList?.CreatedEndDate
                }
                // value={
                //   roleID === 1
                //     ? staffRequestSearch?.CreatedEndDate
                //     : publicDefenderSearch?.CreatedEndDate
                // }
                minDate={isPublicDefender
                  ? staffRequestDefenderSearchList?.CreatedStartDate
                    ? staffRequestDefenderSearchList?.CreatedStartDate
                    : new Date(2017, 0, 1)
                  : staffRequestSearchList?.CreatedStartDate
                    ? staffRequestSearchList?.CreatedStartDate
                    : new Date(2017, 0, 1)
                }
                // maxDate={new Date()}
                maxDate={
                  isPublicDefender
                    ? staffRequestDefenderSearchList?.CreatedStartDate !== ""
                      ? new Date(Math.min(new Date(staffRequestDefenderSearchList?.CreatedStartDate).setFullYear(
                        new Date(staffRequestDefenderSearchList?.CreatedStartDate).getFullYear() + 1), new Date()))
                      : new Date()
                    : staffRequestSearchList?.CreatedStartDate !== ""
                      ? new Date(Math.min(new Date(staffRequestSearchList?.CreatedStartDate).setFullYear(
                        new Date(staffRequestSearchList?.CreatedStartDate).getFullYear() + 1), new Date()))
                      : new Date()
                  //  : new Date(2017, 0, 1)
                }
                isClearable={
                  false
                }
                handleBlur={(e) => handleDateBlur(e, "CreatedEndDate")}
                handleKeyDown={(e) => handleDateEnterKey(e, "CreatedEndDate")}
                errorMessage={errorMessage}
              />
            </div>
          </div>

          <div className="col-sm-6 col-md-6 col-lg-4">
            <div className="form-floating mb-3">
              <SelectInput
                name="ActiveStatus"
                options={RequestStatus}
                label="Status"
                // value={
                //   roleID === 1
                //     ? staffRequestSearch?.ActiveStatus
                //     : publicDefenderSearch?.ActiveStatus
                // }
                value={isPublicDefender
                  ? staffRequestDefenderSearchList?.ActiveStatus
                  : staffRequestSearchList?.ActiveStatus
                }
                isClearable={isPublicDefender
                  ? staffRequestDefenderSearchList?.ActiveStatus !== 2
                  : staffRequestSearchList?.ActiveStatus !== 2
                }
                handleChange={(e) => handleChange(e, "ActiveStatus")}
              />
            </div>
          </div>
          <div className="col-sm-6 col-md-6 col-lg-4">
            <div className="form-floating mb-3">
              <DateInput
                label="Response Start Date"
                name="ResponseStartDate"
                handleChange={(e) => handleChange(e, "ResponseStartDate")}
                placeholderText="Select a date"
                yearDropDown={true}
                // value={
                //   roleID === 1
                //     ? staffRequestSearch?.ResponseStartDate
                //     : publicDefenderSearch?.ResponseStartDate
                // }
                value={isPublicDefender
                  ? staffRequestDefenderSearchList?.ResponseStartDate
                  : staffRequestSearchList?.ResponseStartDate
                }
                isClearable={isPublicDefender
                  ? staffRequestDefenderSearchList?.ResponseStartDate
                  : staffRequestSearchList?.ResponseStartDate
                }
                minDate={new Date(2017, 0, 1)}
                maxDate={isPublicDefender &&
                  staffRequestDefenderSearchList?.ResponseEndDate !== ""
                  ? staffRequestDefenderSearchList?.ResponseEndDate
                  : staffRequestSearchList?.ResponseEndDate !== ""
                    ? staffRequestSearchList?.ResponseEndDate
                    : new Date()
                }
                handleBlur={(e) => handleResDateBlur(e, "ResponseStartDate")}
                handleKeyDown={(e) =>
                  handleDateEnterKey(e, "ResponseStartDate")
                }
              />
            </div>
          </div>
          <div className="col-sm-6 col-md-6 col-lg-4">
            <div className="form-floating mb-3">
              <DateInput
                label="Response End Date"
                name="ResponseEndDate"
                handleChange={(e) => handleChange(e, "ResponseEndDate")}
                placeholderText="Select a date"
                yearDropDown={true}
                // value={
                //   roleID === 1
                //     ? staffRequestSearch?.ResponseEndDate
                //     : publicDefenderSearch?.ResponseEndDate
                // }
                value={isPublicDefender
                  ? staffRequestDefenderSearchList?.ResponseEndDate
                  : staffRequestSearchList?.ResponseEndDate
                }
                isClearable={isPublicDefender
                  ? staffRequestDefenderSearchList?.ResponseEndDate
                  : staffRequestSearchList?.ResponseEndDate
                }
                minDate={isPublicDefender
                  ? staffRequestDefenderSearchList?.ResponseStartDate
                    ? staffRequestDefenderSearchList?.ResponseStartDate
                    : new Date(2017, 0, 1)
                  : staffRequestSearchList?.ResponseStartDate
                    ? staffRequestSearchList?.ResponseStartDate
                    : new Date(2017, 0, 1)
                }
                maxDate={new Date()}
                handleBlur={(e) => handleResDateBlur(e, "ResponseEndDate")}
                handleKeyDown={(e) => handleDateEnterKey(e, "ResponseEndDate")}
              />
            </div>
          </div>

          <div className="col-sm-6 col-md-6 col-lg-4">
            <div className="form-floating mb-3">
              <SelectInput
                name="PodID"
                options={PODList}
                label="POD"
                handleChange={(e) => handleChange(e, "PodID")}
                // value={
                //   roleID === 1
                //     ? staffRequestSearch?.PodID
                //     : publicDefenderSearch?.PodID
                // }
                value={isPublicDefender
                  ? staffRequestDefenderSearchList?.PodID
                  : staffRequestSearchList?.PodID
                }
                isClearable={isPublicDefender
                  ? staffRequestDefenderSearchList?.PodID
                  : staffRequestSearchList?.PodID
                }
              />
            </div>
          </div>

          <div className="col-sm-6 col-md-6 col-lg-4">
            <div className="form-floating mb-3">
              <TextInput
                // name={roleID === 1 ? "InmatesId" : "InmateID"}
                name={isPublicDefender
                  ? "InmateResidentID"
                  : "InmateResidentID"
                }
                label="Inmate ID"
                placeholder="Enter Inmate ID"
                value={isPublicDefender
                  ? staffRequestDefenderSearchList?.InmateResidentID !== ""
                    ? staffRequestDefenderSearchList?.InmateResidentID
                    : ""
                  : staffRequestSearchList?.InmateResidentID !== ""
                    ? staffRequestSearchList?.InmateResidentID
                    : ""
                }
                maxLength={10}
                handleChange={(e) => handleChange(e)}
              />
            </div>
          </div>

          <div className="col-sm-6 col-md-6 col-lg-4">
            <div className="form-floating mb-3">
              <TextInput
                // name={roleID === 1 ? "UserLastName" : "LastName"}
                name={isPublicDefender
                  ? "LastName"
                  : "UserLastName"
                }
                label="Inmate Last Name"
                placeholder="Enter Last Name"
                maxLength={50}
                // value={
                //   roleID === 1
                //     ? staffRequestSearch?.UserLastName
                //     : publicDefenderSearch?.LastName
                // }
                value={isPublicDefender
                  ? staffRequestDefenderSearchList?.LastName
                  : staffRequestSearchList?.UserLastName
                }
                handleChange={(e) => handleChange(e)}
              />
            </div>
          </div>

          <div className="col-sm-6 col-md-6 col-lg-4">
            <div className="form-floating mb-3">
              <TextInput
                // name={roleID === 1 ? "UserFirstName" : "FirstName"}
                name={isPublicDefender
                  ? "FirstName"
                  : "UserFirstName"
                }
                label="Inmate First Name"
                placeholder="Enter First Name"
                maxLength={30}
                // value={
                //   roleID === 1
                //     ? staffRequestSearch?.UserFirstName
                //     : publicDefenderSearch?.FirstName
                // }
                value={isPublicDefender
                  ? staffRequestDefenderSearchList?.FirstName
                  : staffRequestSearchList?.UserFirstName
                }
                handleChange={(e) => handleChange(e)}
              />
            </div>
          </div>
          {roleID !== UserRoleType?.PublicDefender &&
            roleID !== UserRoleType?.PublicDefenderAdmin && (
              <div className="col-sm-6 col-md-6 col-lg-4">
                <div className="form-floating mb-3">
                  <SelectInput
                    name="IsCreatedByMGUser"
                    options={UserList}
                    label="Created By"
                    value={staffRequestSearchList?.IsCreatedByMGUser}
                    handleChange={(e) => handleChange(e, "IsCreatedByMGUser")}
                    isClearable={
                      staffRequestSearchList?.IsCreatedByMGUser !== 2
                    }
                  />
                </div>
              </div>
            )}
        </div>

        {/* Buttons */}
        <div className="d-flex flex-wrap justify-content-center gap-2 flex-wrap mt-3">
          <Button
            variant="primary"
            className="me-2"
            label={"SEARCH"}
            type={"submit"}
            status={"primary"}
            disabled={false}
            icon={"search"}
          />

          <Button
            variant="secondary"
            className="me-2"
            onClick={handleSearchReset}
            label={"RESET"}
            type={"button"}
            status={"secondary"}
            disabled={false}
            icon={"fa-solid fa-rotate-right"}
          />
        </div>
      </form>
    );
  };

  const toggleInformation = () => {
    setShowSearchFields((prev) => !prev);
  };

  const handleBack = () => {
    navigate("/Admin/Dashboard");
  }
  return (
    <>
      <div className={`main-content`}>
        {facilityCode > 0 ? (
          <div className="staff-request">
            <div className="d-flex flex-wrap flex-column justify-content-center align-items-center position-relative">
              {/* web only */}
              <div className="d-none d-md-block card shadow-sm b-r-all  p-4 border border-dark-grey mt-3 w-100">
                <div className="mb-2 d-flex flex-wrap justify-content-between ">
                  <h2 className="  text-color">REQUEST SEARCH</h2>
                  <div className="d-flex flex-wrap gap-3 align-items-center">
                    {showPrivateConversationBtn && (
                      <div className="position-relative d-flex flex-wrap  align-items-center gap-3">
                        <Button
                          variant="success"
                          className="me-2"
                          status="btn-label"
                          label={"Private Conversation"}
                          type="button"
                          imgsrc={privateConversation}
                          // disabled={facilityInformationData?.PrePopulate}
                          onClick={() =>
                            history?.navigate(
                              "StaffRequestList/PrivateConversation"
                            )
                          }
                        />

                        {LoadPrivateConversationRequestUnreadCountResponse?.PCRequestUnReadCount >
                          0 && (
                            <div className="absolute  message-to-inmate-count animate-blink">
                              {
                                LoadPrivateConversationRequestUnreadCountResponse?.PCRequestUnReadCount
                              }
                            </div>
                          )}
                      </div>
                    )}
                    {roleID !== 6 && (
                      <div className="position-relative">
                        <Button
                          label="Initiate Message to Inmate"
                          type="button"
                          status="btn-label"
                          imgsrc={InitiateMessage}
                          // onClick={() =>
                          //   history?.navigate("StaffRequestList/MessageToInmate")
                          // }
                          onClick={() => {
                            handleMessageToInmate();
                          }}
                        />
                        {inmateMessageCount?.RequestUnReadCount > 0 && (
                          <div className="absolute message-to-inmate-count animate-blink">
                            {inmateMessageCount?.RequestUnReadCount}
                          </div>
                        )}
                      </div>
                    )}
                    {isBacktoDashboard && (
                      <div className="d-flex flex-wrap gap-3">
                        <Button
                          label="BACK To DashBoard"
                          type="button"
                          className=" me-2"
                          onClick={() => handleBack()}
                          variant="danger"
                          status={"primary"}
                          icon={"fa-solid fa-angle-left"}
                          disabled={false}
                        />
                      </div>
                    )}
                  </div>
                </div>

                {renderSearch()}
              </div>

              {/* Mobile Only */}
              <div className="d-block d-md-none card shadow-sm b-r-all  p-4 border border-dark-grey mt-3 w-100">
                <div className="d-flex flex-wrap gap-3 align-items-center">
                  {showPrivateConversationBtn && (
                    <div className="position-relative d-flex flex-wrap  align-items-center gap-3">
                      <Button
                        variant="success"
                        className="me-2"
                        status="btn-label"
                        label={"Private Conversation"}
                        type="button"
                        imgsrc={privateConversation}
                        // disabled={facilityInformationData?.PrePopulate}
                        onClick={() =>
                          history?.navigate(
                            "StaffRequestList/PrivateConversation"
                          )
                        }
                      />

                      {LoadPrivateConversationRequestUnreadCountResponse?.PCRequestUnReadCount >
                        0 && (
                          <div className="absolute  message-to-inmate-count animate-blink">
                            {
                              LoadPrivateConversationRequestUnreadCountResponse?.PCRequestUnReadCount
                            }
                          </div>
                        )}
                    </div>
                  )}
                  {roleID !== 6 && (
                    <div className="position-relative">
                      <Button
                        label="Initiate Message to Inmate"
                        type="button"
                        status="btn-label"
                        imgsrc={InitiateMessage}
                        // onClick={() =>
                        //   history?.navigate("StaffRequestList/MessageToInmate")
                        // }
                        onClick={() => {
                          handleMessageToInmate();
                        }}
                      />
                      {inmateMessageCount?.RequestUnReadCount > 0 && (
                        <div className="absolute message-to-inmate-count animate-blink">
                          {inmateMessageCount?.RequestUnReadCount}
                        </div>
                      )}
                    </div>
                  )}
                  {isBacktoDashboard && (
                    <div className="d-flex flex-wrap gap-3">
                      <Button
                        label="BACK To DashBoard"
                        type="button"
                        className=" me-2"
                        onClick={() => handleBack()}
                        variant="danger"
                        status={"primary"}
                        icon={"fa-solid fa-angle-left"}
                        disabled={false}
                      />
                    </div>
                  )}
                </div>
              </div>
              <div className="d-block d-md-none card shadow-sm b-r-all  p-4 border border-dark-grey mt-3 w-100">
                <div
                  className=" d-flex align-items-center justify-content-between"
                  style={{ background: "transparent", cursor: "pointer" }}
                  onClick={toggleInformation}
                >
                  <h2 className="form_title_uppercase text-color">
                    REQUESTS SEARCH
                  </h2>
                  <i
                    id="itagInformation"
                    className={`fa fa-angle-down ${showSearchFields ? "rotate" : ""
                      }`}
                    style={{ fontSize: "20px" }}
                  ></i>
                </div>

                <div className="mt-2">{showSearchFields && renderSearch()}</div>
              </div>

              <div className="card shadow-sm b-r-all  p-4 border border-dark-grey mt-3 w-100 ">
                <div className="d-flex flex-wrap justify-content-between align-items-center mb-2 resp-space">
                  <h2 className=" text-color">REQUESTS LIST</h2>

                  <div className="d-flex flex-wrap  align-items-center gap-3">
                    {((publicDefenderList &&
                      publicDefenderList?.DataList?.length > 0) ||
                      (staffRequestList &&
                        staffRequestList?.DataList?.length > 0)) && (
                        <Button
                          variant="secondary"
                          onClick={() => handleReviewRequest()}
                          className="me-2"
                          label="Review Request Here"
                          type="button"
                          imgsrc={review}
                          //icon={"fa-solid fa-file-circle-check"}
                          status="btn-label"
                          disabled={false}
                        />
                      )}
                    {messageTypeList?.length > 0 && (
                      <Button
                        variant="success"
                        className="me-2"
                        onClick={() =>
                          history.navigate("/Admin/StaffRequestList/Add", {
                            state: { createFormSource: "staffRequestList" },
                          })
                        }
                        label="Create New"
                        type="button"
                        status="btn-label"
                        imgsrc={createicon}
                      // icon={"circle-plus"}
                      />
                    )}

                    {(publicDefenderList?.DataList?.length > 0 ||
                      staffRequestList?.DataList?.length > 0) && (
                        <ExcelExport handleExcelExport={exportDocAsExcel} />
                      )}
                  </div>
                </div>

                <Table
                  columns={columns}
                  data={
                    isPublicDefender ? publicDefenderList?.DataList
                      : staffRequestList?.DataList
                  }
                  pagination
                  onChangeRowsPerPage={(page) => handleRowPerPage(page)}
                  onChangePage={(page) => handlePageChange(page)}
                  totalRowCount={
                    isPublicDefender
                      ? publicDefenderList?.TotalRecordCount
                      : staffRequestList?.TotalRecordCount
                  }
                  currentPage={isPublicDefender
                    ? staffRequestDefenderSearchList?.PageNo
                    : staffRequestSearchList?.PageNo
                  }
                  paginationPerPage={isPublicDefender
                    ? staffRequestDefenderSearchList?.RowCountPerPage
                    : staffRequestSearchList?.RowCountPerPage
                  }
                  serverSideSort
                  onSort={handleSort}
                  sortColumn={isPublicDefender
                    ? staffRequestDefenderSearchList?.SortBy?.split(" ")[0]
                    : staffRequestSearchList?.SortBy?.split(" ")[0]
                  }
                  sortDirection={isPublicDefender
                    ? staffRequestDefenderSearchList?.SortBy?.split(" ")[1]
                    : staffRequestSearchList?.SortBy?.split(" ")[1]
                  }
                />
              </div>
            </div>
          </div>
        ) : (
          <h4 className="facility-card">
            Select a Facility Code from the list
          </h4>
        )}
      </div>
    </>
  );
}

export default React.memo(StaffRequestList);
